module.exports = __webpack_public_path__ + "images/1b05d7afe4d3fd685546917e9b96a40b.png";